__turbopack_context__.v({
  "cardsWrapper": "pagayaCard-module-scss-module__kp4SmW__cardsWrapper",
  "inputWrapper": "pagayaCard-module-scss-module__kp4SmW__inputWrapper",
  "pagayaLogo": "pagayaCard-module-scss-module__kp4SmW__pagayaLogo",
  "subTitle": "pagayaCard-module-scss-module__kp4SmW__subTitle",
  "title": "pagayaCard-module-scss-module__kp4SmW__title",
});
